import { useState } from "react";

/**
 * Lets the user reveal the shifts the active filter hides, without clearing the
 * filter. Tracking which filter the reveal applies to makes it reset on its own
 * whenever the filter value changes.
 */
export const useRevealNonMatchingShifts = (filterValue: string) => {
  const [revealedForFilter, setRevealedForFilter] = useState<string | null>(
    null,
  );

  return {
    areNonMatchingShiftsRevealed: revealedForFilter === filterValue,
    revealNonMatchingShifts: () => setRevealedForFilter(filterValue),
  };
};
